// extracted by mini-css-extract-plugin
module.exports = {"section":"ProductDetail_section__1L8HO","item":"ProductDetail_item__BTSkA"};